import { render, staticRenderFns } from "./Shopban.vue?vue&type=template&id=0403b956&scoped=true"
import script from "./Shopban.vue?vue&type=script&lang=js"
export * from "./Shopban.vue?vue&type=script&lang=js"
import style0 from "./Shopban.vue?vue&type=style&index=0&id=0403b956&prod&lang=css"
import style1 from "./Shopban.vue?vue&type=style&index=1&id=0403b956&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0403b956",
  null
  
)

export default component.exports